export default function samplesToMs(samples, rate = 44100) {
	return (samples / rate) * 1000;
}
